import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RegistrationService } from '../../registration.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-form-view',
  templateUrl: './form-view.component.html',
  styleUrls: ['./form-view.component.css']
})
export class FormViewComponent implements OnInit {
  sainikDetails: any={};
  data: any;
  title = "Sainik Details";
  s:any={};
  
  constructor(private service: RegistrationService,private handleError:HandleError) {
    //this.sainikDetails={};
   // this.sainikDetails.Ranks={};
  }

  ngOnInit() {
  }

  GetSainikDetails(SR_ServiceNo,form: NgForm){
    this.data="";
    this.sainikDetails="";
    this.data = this.service.getSainikDetails(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.sainikDetails=response;
        
      }, (error) => {
        console.log(error);
        if (error.status == 400){
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        //window.location.reload();
        }
        this.handleError.ErrorHandler(error);
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        // else if (error.status == 440||error.status == 401) {
        //    localStorage.clear();
        //    this.change.emit(true);
        //    this.router.navigate(['/login']);
        //   swal({ title: 'Sorry', text: 'Your current session got expired! Please login again.', type: 'info'});
        // }

      });
  }
 
}



// WEBPACK FOOTER //
// ./src/app/forms/form-view/form-view.component.ts